import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InfoPopover } from '@/components/common/info-popover';
import { Select } from '@/components/form/select';

import { IDropdownOption } from '../utils/dropdown-option-mapper';

export interface IDropdownProps {
  name: string;
  label: string;
  control: any;
  infoBubble?: JSX.Element | string;
  defaultValue: string | number | undefined;
  options: IDropdownOption[];
  parser?: any;
  classnames?: string;
  labelWidth?: string;
  dropdownWidth?: string;
}

export const SettingDropdownItem: React.FC<IDropdownProps> = ({
  name,
  label,
  options,
  control,
  infoBubble,
  defaultValue,
  parser = String,
  classnames = '',
  labelWidth = 'w-full',
  dropdownWidth = 'w-52',
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <span className={`flex gap-2 ${labelWidth} text-lg text-gray-600`}>
        <div>{t(label)}</div>
        {infoBubble && <InfoPopover type="info">{infoBubble}</InfoPopover>}
      </span>
      <Controller
        render={({ field: { onChange, value } }) => (
          <Select
            defaultValue={value}
            classnames={`${dropdownWidth} ${classnames}`}
            menuItemClassnames={dropdownWidth}
            onChange={(value) => onChange(parser(value))}
            options={[...options.map(({ label, value }) => ({ label, value }))]}
          />
        )}
        control={control}
        name={name}
        defaultValue={defaultValue}
      />
    </div>
  );
};
